/**
 * @generated SignedSource<<2dbe7d2d2cc2599a2753cd9deb5f8263>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventIcon_event$data = {
  readonly __typename: "TodoTimelineUpdateEventAssignedEmployees";
  readonly __typename: "TodoTimelineUpdateEventAssignedEmployees";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventAssignedRoles";
  readonly __typename: "TodoTimelineUpdateEventAssignedRoles";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventAssignedTeams";
  readonly __typename: "TodoTimelineUpdateEventAssignedTeams";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventBody";
  readonly __typename: "TodoTimelineUpdateEventBody";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventCategory";
  readonly __typename: "TodoTimelineUpdateEventCategory";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventExpireAt";
  readonly __typename: "TodoTimelineUpdateEventExpireAt";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventPriority";
  readonly __typename: "TodoTimelineUpdateEventPriority";
  readonly newPriority: TodoPriority;
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventStatus";
  readonly __typename: "TodoTimelineUpdateEventStatus";
  readonly newStatus: TodoStatus;
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventTags";
  readonly __typename: "TodoTimelineUpdateEventTags";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  readonly __typename: "TodoTimelineUpdateEventTitle";
  readonly __typename: "TodoTimelineUpdateEventTitle";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "TodoTimelineUpdateEventIcon_event";
};
export type TodoTimelineUpdateEventIcon_event$key = {
  readonly " $data"?: TodoTimelineUpdateEventIcon_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventIcon_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventIcon_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newStatus",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventStatus",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newPriority",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventPriority",
      "abstractKey": null
    }
  ],
  "type": "TodoTimelineUpdateEvent",
  "abstractKey": "__isTodoTimelineUpdateEvent"
};

(node as any).hash = "8013a81b2075de502fbe79043bce903c";

export default node;
